import {type NavigationGuardNext, type RouteLocationNormalized} from 'vue-router'
import {useAccountStore} from "@domains/account/stores/account.store";

export const getLoginActivityResolver = async (
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext): Promise<void> => {

    const accountStore = useAccountStore();
    accountStore.loadUserLoginActivities().then(() => next());
}
